<div class="flex-column gap-4 f-1-0 animated fadeIn">
    <div class="flex-row gap-2 align-items-center">
        <input type="text" class="m-0 f-1-0" style="height: 32px; max-width: 400px;"
               (keyup.enter)="checkSpfRecord();"
               placeholder="Domain to check"
               [(ngModel)]="domainTxt">
        <btn-c [isDisabled]="!domainTxt || checkSpfRecordInProcess" (action)="checkSpfRecord();">
            Check
        </btn-c>
    </div>

    <div class="ms-2 p-3 flex-column gap-3" style=" max-width: 1000px; height: 450px; box-shadow: 0 0 10px lightgrey;"
         *ngFor="let result of checkSpfRecordResult"
         [id]="result.rootDomain">
        <h6>SPF results for domain: <b>{{result.rootDomain}}</b></h6>
        <div class="flex-row align-items-center gap-3 bg-success bg-opacity-10 border border-success rounded-2 px-3 py-2">
            <span class="text-success" style="font-size: 14px;">
                {{result.spfRecord}}
            </span>
            <i class="far fa-copy copy-link opacity-75 hvr-opacity" tooltip="Copy SPF record value" (click)="gs.copyToClipboard(result.spfRecord);"></i>
        </div>

        <!--SPF record items table-->
        <trustifi-table-c
                class="trustifi-table" style="flex: 1 0; z-index: 5;"
                [list]="result.items"
                [headers]="[
                    {text: 'Qualifier', width: '80px', centered: true},
                    {text: 'Qualifier Description', width: '145px'},
                    {text: 'Type', width: '80px'},
                    {text: 'Value', width: '35%'},
                    {text: 'Description', width: '65%'},
                ]"
                [cellsPrototype]="[
                    {textKey: 'qualifier', style: {'width': '100%', 'display': 'block', 'text-align': 'center'}},
                    {textKey: 'qualifierDesc'},
                    {textKey: 'mechanism'},
                    {html: 'valueCell'},
                    {textKey: 'description'},
                ]"
                [options]="{
                    itemsNameSingular: 'record',
                    isEllipsis: false,
                    hideContentAboveTable: true
                }"
        >
            <ng-template #customCells let-item let-cellId="cellId">
                <!--value cells-->
                <span *ngIf="cellId === 'valueCell'">
                    <a class="blue-link"
                       *ngIf="item.mechanism === 'include' || item.mechanism === 'redirect' || item.mechanism === 'exists'
                            || item.mechanism === 'ptr' || ((item.mechanism === 'a' || item.mechanism === 'mx') && item.value); else notClickable"
                       (click)="checkSpfSubdomainRecord(item.value)">
                        {{item.value}}
                    </a>
                     <ng-template #notClickable>
                         {{item.value}}
                    </ng-template>
				</span>
            </ng-template>
        </trustifi-table-c>
    </div>

    <loader class="opacity-75 align-self-center" height="80" width="80" *ngIf="checkSpfRecordInProcess"></loader>
</div>
